import * as zod from 'zod';

import { Step } from '@sb/remote-control/types';
import { buildConditionalFromJSON } from '@sb/remote-control/util/conditionalsBuilder';

export namespace AntigravityStep {
  export const name = 'Antigravity';
  export const description =
    'Pause routine and allow antigravity positioning. Resume when done.';
  export const librarySection = Step.LibrarySection.InterfaceWithOperators;
  export const featureFlag = 'antigravityStep' as const;

  export const argumentKind = 'Antigravity';

  export const Arguments = zod.object({
    argumentKind: zod.literal(argumentKind),
    message: zod.string().optional(),
    condition: zod.string().nullable().default(null),
  });

  export type Arguments = zod.infer<typeof Arguments>;

  export const toRoutineRunner: Step.ToRoutineRunner = ({
    stepConfiguration: { args },
    stepData,
  }) => {
    if (args?.argumentKind !== argumentKind) {
      throw new TypeError(`Expected argument kind ${argumentKind}`);
    }

    const condition = args.condition
      ? buildConditionalFromJSON(args.condition)
      : null;

    return {
      ...stepData,
      stepKind: 'Antigravity',
      args: {
        message: args.message,
        condition,
      },
    };
  };
}

AntigravityStep satisfies Step.StepKindInfo;
